import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { MyCarsCtas } from 'wsm-mycars-ctas';
import { useLabels } from 'wsm-common-data';
import { selectIsTabbedLayout } from '../../../utilities/layout';
import { useMyCarsSiteProperties } from '../../../hooks';
import vehiclePropType from '../../../propTypes/vehiclePropType';
import { pricingMap } from '../../../utilities/pricingMap';

const MyCars = ({
	vehicle: {
		uuid,
		title,
		images,
		pricing,
		accountId,
		bodyStyle,
		condition,
		make,
		model,
		priorityType,
		stockNumber,
		trim,
		type,
		vin,
		year
	}
}) => {
	const labels = useLabels();
	const isTabbedLayout = useSelector((state) => selectIsTabbedLayout(state));
	const siteId = useSelector((state) => state.widgetInfo.siteId);
	const componentPricing = pricingMap(pricing);
	const finalPrice = useMemo(
		() =>
			componentPricing?.dPrice?.find((price) => price?.isFinalPrice)
				?.value || null,
		[componentPricing]
	);
	const { enableMyCars } = useMyCarsSiteProperties();

	const modernMyCarsLabels = [
		{
			id: 'trackPrice',
			default: labels.get('TRACK_PRICE')
		},
		{
			id: 'save',
			default: labels.get('SAVE')
		}
	];

	if (enableMyCars) {
		return (
			<MyCarsCtas
				uuid={uuid}
				title={title}
				price={finalPrice}
				image={images?.[0] || null}
				isInLine={!isTabbedLayout}
				labels={modernMyCarsLabels}
				accountId={accountId}
				siteId={siteId}
				bodyStyle={bodyStyle}
				condition={condition}
				make={make}
				model={model}
				priorityType={priorityType}
				stockNumber={stockNumber}
				trim={trim}
				// TODO: `vehicle.type` will always be a string once all sites are on WIS,
				// so this string conversion will be unnecessary
				type={String(type)}
				vin={vin}
				year={year}
			/>
		);
	} else {
		return null;
	}
};

MyCars.propTypes = {
	vehicle: vehiclePropType.isRequired
};

export default MyCars;
